<template>
  <div class="DevicesNodeOutput">
    <div class="DevicesNodeOutput-wrapper-rightIcon lxn-h100 lxn-border-round" :class="$store.getters.language.floatClass">
      <ButtonIcon :size="40" bgColor="#ECECEC" :icon="icon" iconColor="#8F8F8F" :padding="8" />
    </div>
    <div class="DevicesNodeOutput-wrapper-left lxn-h100 lxn-border-round lxn-overflow-hidden" :class="$store.getters.language.floatClassReverse">
      <div class="DevicesNodeOutput-wrapper-leftIcon lxn-h100" :class="$store.getters.language.floatClassReverse" @click="$router.push('/Output' + output.type + 'Settings/' + node.uuid + '/' + index)">
        <ButtonIcon :size="40" bgColor="#1EA5DE" icon="cog" iconColor="#FFFFFF" :padding="8" />
      </div>
      <div class="DevicesNodeOutput-name lxn-h100 lxn-overflow-hidden lxn-text" :class="[$store.getters.language.floatClass, $store.getters.language.directionClass, $store.getters.language.textAlignClass, $store.getters.language.font]">
        {{output.name}}
      </div>
    </div>
  </div>
</template>

<script>
import ButtonIcon from '@/components/ButtonIcon.vue'

export default {
  name: 'NodeOutput',
  props: {
    index: Number,
    nodeIndex: Number
  },
  components: {
    ButtonIcon
  },
  data: function () {
    return {
    }
  },
  computed: {
    node: function() {
      return this.$store.state.nodes[this.nodeIndex];
    },
    output: function() {
      return this.node.outputs[this.index];
    },
    name: function() {
      return this.output.name;
    },
    icon: function() {
      return this.output.icon;
    }
  },
  methods: {
  }
}
</script>

<style>
  .DevicesNodeOutput {
    margin-top: 10px;
    height: 50px;
  }
  .DevicesNodeOutput-wrapper-rightIcon {
    width: 50px;
    background-color: #DEDEDE;
    padding: 5px;
  }
  .DevicesNodeOutput-name {
    line-height: 50px;
    width: calc(100% - 50px);
    text-indent: 5px;
  }
  .DevicesNodeOutput-wrapper-left {
    width: calc(100% - 55px);
    background-color: #ECECEC;
  }
  .DevicesNodeOutput-wrapper-leftIcon {
    padding: 5px;
  }
</style>
